import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import Container from '../../styles/Container'
import { Paragraph } from '../../styles/Text'

import pusherDesignLogoPusher from '../../images/pusher-design-logo-pusher.svg'
import pusherDesignLogoDesign from '../../images/pusher-design-logo-design.svg'

const OuterContainer = styled.div`
  background-color: white;
  z-index: 2;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    position: sticky;
    top: 0px;
  }
`

const CustomContainer = styled(Container)`
  position: relative;
  padding-left: 16px;
  padding-right: 16px;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    padding-left: 24px;
    padding-right: 24px;
    max-width: 100%;
  }
  @media (min-width: ${(p) => p.theme.breakpointXl}) {
    max-width: 100%;
    padding-left: 32px;
    padding-right: 32px;
  }
`

const NavbarContent = styled.div`
  display: flex;
  justify-content: space-between;
  height: 76px;
  align-items: center;
  overflow: auto;
`

const NavbarLogoWrapper = styled.div`
  display: flex;
  align-items: center;
`

const LogoPusher = styled.img`
  height: 36px;
  @media (min-width: ${(p) => p.theme.breakpointMd}) {
    display: block;
  }
`

const LogoCenter = styled.div`
  margin-right: 24px;
  margin-left: 24px;
  width: 1px;
  height: 36px;
  background-color: #b1a7e0;
`

const LogoDesign = styled.img`
  height: 18px;
  @media (min-width: ${(p) => p.theme.breakpointMd}) {
    display: block;
  }
`

const Menu = styled.ul`
  display: none;
  padding-left: 16px;
  white-space: nowrap;
  a {
    font-weight: 600;
  }
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: flex;
    li:not(:last-child) {
      margin-right: 48px;
    }
  }
`

const MobileMenu = styled.ul`
  ${(p) => p.mobileMenuIsHidden && 'display: none;'}
  padding: 24px 0px 32px;
  a {
    font-weight: 600;
  }
  li {
    :not(:first-child) {
      margin-top: 24px;
    }
  }
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: none;
  }
`

const BurgerMenuContainer = styled.div`
  width: 40px;
  height: 40px;
  margin-left: 16px;
  cursor: pointer;
  border-radius: 4px;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: none;
  }
`

const BurgerMenu = styled.span`
  display: block;
  width: 20px;
  height: 2px;
  background-color: ${(p) => p.theme.textColor};
  border-radius: 10px;
  transform: translate(10px, 19px);
  transition: all 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  background-color: ${({ mobileMenuIsHidden }) => !mobileMenuIsHidden && 'transparent'};
  &:before {
    content: '';
    display: block;
    width: 20px;
    height: 2px;
    background-color: ${(p) => p.theme.textColor};
    transform: translateY(-7px);
    border-radius: 10px;
    transition: all 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    transform: ${({ mobileMenuIsHidden }) => !mobileMenuIsHidden && 'translateY(-1px) rotate(45deg)'};
  }
  &:after {
    content: '';
    display: block;
    width: 20px;
    height: 2px;
    background-color: ${(p) => p.theme.textColor};
    transform: translateY(5px);
    border-radius: 10px;
    transition: all 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    transform: ${({ mobileMenuIsHidden }) => !mobileMenuIsHidden && 'translateY(-3px) rotate(-45deg)'};
  }
`

const PusherDesignNavbar = ({ mobileMenuIsHidden, setMobileMenuIsHidden }) => {
  const toggleMobileMenu = () => {
    setMobileMenuIsHidden((s) => !s)
  }
  return (
    <OuterContainer>
      <CustomContainer>
        <NavbarContent>
          <NavbarLogoWrapper>
            <Link to="/">
              <LogoPusher src={pusherDesignLogoPusher} alt="Pusher Logo" />
            </Link>
            <LogoCenter />
            <Link to="/design">
              <LogoDesign src={pusherDesignLogoDesign} alt="Pusher Design Logo" />
            </Link>
          </NavbarLogoWrapper>
          <Menu>
            <Paragraph as="li">
              <Link to="/design">Design</Link>
            </Paragraph>
            <Paragraph as="li">
              <Link to="/design/chameleon">Chameleon</Link>
            </Paragraph>
            <Paragraph as="li">
              <Link to="/design/brand-guidelines">Brand guidelines</Link>
            </Paragraph>
            <Paragraph as="li">
              <Link to="/design/animation">Animation</Link>
            </Paragraph>
            <Paragraph as="li">
              <Link to="/design/media-kit">Media kit</Link>
            </Paragraph>
          </Menu>
          <BurgerMenuContainer
            role="button"
            tabIndex="0"
            aria-label="Burger Menu"
            onClick={toggleMobileMenu}
            onKeyPress={toggleMobileMenu}
          >
            <BurgerMenu mobileMenuIsHidden={mobileMenuIsHidden} />
          </BurgerMenuContainer>
        </NavbarContent>
        <MobileMenu mobileMenuIsHidden={mobileMenuIsHidden}>
          <Paragraph as="li">
            <Link to="/design">Design</Link>
          </Paragraph>
          <Paragraph as="li">
            <Link to="/design/chameleon">Chameleon</Link>
          </Paragraph>
          <Paragraph as="li">
            <Link to="/design/brand-guidelines">Brand guidelines</Link>
          </Paragraph>
          <Paragraph as="li">
            <Link to="/design/animation">Animation</Link>
          </Paragraph>
          <Paragraph as="li">
            <Link to="/design/media-kit">Media kit</Link>
          </Paragraph>
        </MobileMenu>
      </CustomContainer>
    </OuterContainer>
  )
}

export default PusherDesignNavbar
